import { getMessageAlert } from '@/api/cs';
import { useQuery } from 'react-query';

function useGetCsMessage() {
  const { data: messageAlert } = useQuery(
    ['messageAlertList'],
    getMessageAlert,
  );

  const getTotalCount = (key: 'has1on1' | 'hasProcessed') => {
    return (
      messageAlert?.notifications.reduce((acc, cur) => acc + cur[key], 0) || 0
    );
  };

  const total1on1Count = getTotalCount('has1on1');
  const totalProcessedCount = getTotalCount('hasProcessed');
  const recentNewChatId = messageAlert?.notifications.find(
    (notification) => notification.has1on1 > 0,
  )?.chatId;

  const hasTotalCount = total1on1Count > 0 || totalProcessedCount > 0;

  return {
    messageAlert,
    total1on1Count,
    totalProcessedCount,
    hasTotalCount,
    recentNewChatId,
  };
}

export default useGetCsMessage;
